import {SMALL_DEVICE_MEDIA_SIZE} from "components/common/constants";

export const statisticsStyles = theme => ({
    root: {


        [theme.breakpoints.down(SMALL_DEVICE_MEDIA_SIZE)]: {
            paddingRight:"0 !important",
            paddingLeft:"0 !important"
        }

    },
    paperMenu: {
        marginRight: theme.spacing(2),
    },
    responsiveChart: {
        width:"99%",
        height:400,
    },
    responsiveChartContainer: {
        width:"100%",
    } ,
    responsiveTagChart: {
        width:"99%",
        height:600,

    },
    menuItemSelected: {
        color:theme.palette.secondary.main,
        borderRight: "1px solid " +  theme.palette.secondary.main,
        borderLeft: "1px solid " +  theme.palette.secondary.main
    },
    responsiveChartPies: {
        display: "inline-flex",
        width:"100%",
    }
}
);
